import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { UserResponseDto } from 'src/dtos/user/response/userResponseDto';
import { ColumnState } from 'ag-grid-community';
import { defaultSYS3010_R01Dto, SYS3010_R01Dto } from './Dto_SYS3010_R01';
import { CompanyDto } from 'src/dtos/company/companyDto';

export interface SYS3010_R01Filter {
	userNm: string;
}

export interface Store_SYS3010_R01 {
	SYS3010_R01Filter: SYS3010_R01Filter;
	SYS3010_R01PastFilter: SYS3010_R01Filter;
	setSYS3010_R01Filter: (filter: Partial<SYS3010_R01Filter>) => void;
	setSYS3010_R01PastFilter: (filter: Partial<SYS3010_R01Filter>) => void;

	
    SYS3010_R01Info: UserResponseDto | undefined;
    setSYS3010_R01Info: (userInfo: UserResponseDto) => void;

    company: CompanyDto | undefined;
    setCompany: (company: CompanyDto | undefined) => void;

    SYS3010_R01List: SYS3010_R01Dto[];
    setSYS3010_R01List: (userList: SYS3010_R01Dto[]) => void;
    insertSYS3010_R01List: (data: SYS3010_R01Dto[], index?: number) => void;
    removeSYS3010_R01List: (index: number) => void;
    updateSYS3010_R01List: (index: number, data: SYS3010_R01Dto) => void;

    deletedSYS3010_R01List: string[];
    addDeletedSYS3010_R01List: (idList: string[]) => void;
    removeDeletedSYS3010_R01List: (idList?: string[]) => void;

    selectedSYS3010_R01List: string[];
	setSelectedSYS3010_R01List: (idList: string[]) => void;
    addSelectedSYS3010_R01List: (idList: string[]) => void;
    removeSelectedSYS3010_R01List: (idList?: string[]) => void;
	initSelectedSYS3010_R01List: () => void;
	allSelectedSYS3010_R01List: () => void;

	originalSYS3010_R01List: SYS3010_R01Dto[];
	setOriginalSYS3010_R01List: (list: SYS3010_R01Dto[]) => void;

    columnState: ColumnState[] | null;				setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;								setAllCount: (allCount: number) => void;

    initData: () => void;


}

export const defaultSYS3010_R01Filter : SYS3010_R01Filter = {
	userNm: '',
};

export const useSYS3010_R01Store = create<Store_SYS3010_R01>((set) => ({
	SYS3010_R01Filter: defaultSYS3010_R01Filter,
	SYS3010_R01PastFilter: defaultSYS3010_R01Filter,
	setSYS3010_R01Filter: (filter: Partial<SYS3010_R01Filter>) => set((state) => {
		return {
			SYS3010_R01Filter: {
				...state.SYS3010_R01Filter,
				...filter
			}
		}
	}),
	setSYS3010_R01PastFilter: (filter: Partial<SYS3010_R01Filter>) => set((state) => {
		return {
			SYS3010_R01PastFilter: {
				...state.SYS3010_R01PastFilter,
				...filter
			}
		}
	}),
	
    SYS3010_R01Info: undefined,
    setSYS3010_R01Info: (userInfo: UserResponseDto) => set({ SYS3010_R01Info: userInfo }),

    company: undefined,
    setCompany: (company: CompanyDto | undefined) => set({ company }),

    SYS3010_R01List: [],
    setSYS3010_R01List: (SYS3010_R01List: SYS3010_R01Dto[]) => set((state) => {
		let newList: SYS3010_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		SYS3010_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultSYS3010_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			SYS3010_R01List: newList
		}
	}),
	insertSYS3010_R01List: (data: SYS3010_R01Dto[], index?: number) => set((state) => {
		let newSYS3010_R01List = [...state.SYS3010_R01List];

		let targetRowData = newSYS3010_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSYS3010_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS3010_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSYS3010_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS3010_R01List에 대체
		newSYS3010_R01List = newSYS3010_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newSYS3010_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSYS3010_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newSYS3010_R01List.splice(index, 0, ...newData);
		} else {
			newSYS3010_R01List.push(...newData);
		}

		return {
			...state,
			SYS3010_R01List: newSYS3010_R01List
		}
	}),
	removeSYS3010_R01List: (index: number) => set((state) => {
		const newSYS3010_R01List = [...state.SYS3010_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SYS3010_R01List: newSYS3010_R01List
		}
	}),
	updateSYS3010_R01List: (valueIndex: number, data: SYS3010_R01Dto) => set((state) => {
		const _SYS3010_R01List = state.SYS3010_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SYS3010_R01List: _SYS3010_R01List
		}
	}),

    deletedSYS3010_R01List: [],
    addDeletedSYS3010_R01List: (idList: string[]) => set((state) => {
        const _deletedUserList = [...state.deletedSYS3010_R01List];
		
		for(const valueIndex of idList) {
			const isInserted = state.SYS3010_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SYS3010_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedUserList.push(valueIndex);
			}
		}

        return {
            ...state,
            deletedSYS3010_R01List: _deletedUserList
        }
    }),
    removeDeletedSYS3010_R01List: (idList?: string[]) => set((state) => ({
        ...state,
        deletedSYS3010_R01List: [...state.deletedSYS3010_R01List].filter(value => idList ? !idList.includes(value) : false)
    })),

    selectedSYS3010_R01List: [],
	setSelectedSYS3010_R01List: (idList: string[]) => set({ selectedSYS3010_R01List: idList }),
    addSelectedSYS3010_R01List: (idList: string[]) => set((state) => {
        const _selectedUserList = [...state.selectedSYS3010_R01List];
        _selectedUserList.push(...(idList.filter(value => !_selectedUserList.includes(value))));

        return {
            ...state,
            selectedSYS3010_R01List: _selectedUserList
        }
    }),
    removeSelectedSYS3010_R01List: (idList?: string[]) => set((state) => ({
        ...state,
        selectedSYS3010_R01List: [...state.selectedSYS3010_R01List].filter(value => idList ? !idList.includes(value) : false)
    })),
	initSelectedSYS3010_R01List: () => set({ selectedSYS3010_R01List: [] }),
	allSelectedSYS3010_R01List: () => set((state) => ({
		selectedSYS3010_R01List: state.SYS3010_R01List.map(item => item.valueIndex.toString())
	})),

	originalSYS3010_R01List: [],
    setOriginalSYS3010_R01List: (SYS3010_R01List: SYS3010_R01Dto[]) => set((state) => {
		let newList: SYS3010_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		SYS3010_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultSYS3010_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSYS3010_R01List: newList
		}
	}),

    columnState: null,		setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

    initData: () => set((state) => ({
        ...state,
		SYS3010_R01Filter: defaultSYS3010_R01Filter,
		SYS3010_R01PastFilter: defaultSYS3010_R01Filter,
		SYS3010_R01Info: undefined,
		company: undefined,
        SYS3010_R01List: [],
        selectedSYS3010_R01List: [],
        deletedSYS3010_R01List: [],
		allCount: 0,
		scrollTop: null,
    }))
}));
